import * as THREE from "three";

export class RendererController {
  constructor({ canvas, profile }) {
    this.canvas = canvas;
    this.profile = profile;

    this.instance = new THREE.WebGLRenderer({
      canvas,
      antialias: !profile.isMobile,
      alpha: true,
      powerPreference: profile.isMobile ? "low-power" : "high-performance"
    });

    this.instance.outputColorSpace = THREE.SRGBColorSpace;
    this.instance.toneMapping = THREE.ACESFilmicToneMapping;
    this.instance.toneMappingExposure = 1.3;
    this.instance.setClearColor("#ffffff", 0);

    this.setSize(window.innerWidth, window.innerHeight);
  }

  setSize(width, height) {
    this.instance.setSize(width, height);
    const pixelRatio = Math.min(window.devicePixelRatio || 1, this.profile.maxPixelRatio);
    this.instance.setPixelRatio(pixelRatio);
  }

  render(scene, camera) {
    this.instance.render(scene, camera);
  }

  dispose() {
    this.instance.dispose();
  }
}
